import { render, staticRenderFns } from "./PatientNavbarItem.vue?vue&type=template&id=2547087e&scoped=true&"
import script from "./PatientNavbarItem.vue?vue&type=script&lang=ts&"
export * from "./PatientNavbarItem.vue?vue&type=script&lang=ts&"
import style0 from "./PatientNavbarItem.vue?vue&type=style&index=0&id=2547087e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547087e",
  null
  
)

export default component.exports